import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/machine-checks/_layout/'
)({ component: () => null });
